export default {
    submissions: {
        upvote: [],
        downvote:[]
    },

    comments: {
        likes: [],
    },

    bookmarks: {
        submissions: [],
        comments: [],
        channels: [],
        users: []
    },

    blocks: {
        users: [],
        channels: []
    },

    moderatingChannels: [],
    bookmarkedChannels: [],
    moderatorAt: [],
    administratorAt: [],
    moderatingAt: [], // contains both moderator and administrator
    subscribedAt: [],

    notifications: [],
    messages: [],
    contacts: [],

    subscribedChannels: []
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/state.js